<template>
  <div
    v-if="typeof price?.minOnlineDelivery == 'number' && price?.minOnlineDelivery > 0 && typeof price?.maxOnlineDelivery == 'number' && price?.maxOnlineDelivery > 0" class="delivery-timing"
    :class="checkoutClass ? 'text-success font-bold lg:order-3 col-span-2 lg:text-xs' : 'text-xs text-paragraph-light'">
    <BasicIcon :name="'truck-solid'" class="w-3 mr-1 delivery-icon" />
    <span :class="checkoutClass ? '' : 'text-xs font-bold text-black'">Lieferung <template v-if="price?.maxOnlineDelivery == 1 || price?.maxOnlineDelivery == price?.minOnlineDelivery">am</template></span>
     {{ price?.maxOnlineDelivery == 1 ? delivery.minDate : price?.maxOnlineDelivery == price?.minOnlineDelivery ? delivery.maxDate : delivery.minDate + ' - ' + delivery.maxDate}}
  </div>
</template>

<script setup lang="ts">
import { getDeliveryDatesFromPrice } from '~/composables/deliveryCalculater'
import type { FullPrice } from "@expert/types";

interface Props {
  price: FullPrice;
  checkoutClass?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  checkoutClass: false,
});

const delivery = getDeliveryDatesFromPrice(props?.price);
</script>
